function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={(styles["feather"] || "feather") + " " + (styles["feather-arrow-left"] || "feather-arrow-left")} {...props}><path d="M19 12H5M12 19l-7-7 7-7" /></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/arrow-left.icon.svg